// import dotProp from 'dot-prop-immutable'

// Selectors
export const getPreviewState = (state) => state.ui.preview
export const getSidebarState = (state) => state.ui.sidebar
export const getButtonsState = (state) => state.ui.buttons

export const getWallpaper = (state) =>
  state.ui.wallpaper.wallpapers[state.ui.wallpaper.currentIndex]
